import React, { useState, useEffect } from "react";
import { FaAlignRight, FaRegTimesCircle, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./Header.css";

const useMediaQuery = (width, showSecond, setShowSecond) => {
  const [targetReached, setTargetReached] = useState(false);

  const updateTarget = (e) => {
    if (e.matches) {
      setTargetReached(true);
      setShowSecond(false)
    } else {
      setTargetReached(false);
    }
  };

  useEffect(() => {
    const media = window.matchMedia(`(min-width: ${width}px)`);
    media.addEventListener('change', updateTarget);

    // Check on mount (callback is not called until a change occurs)
    if (media.matches) {
      setTargetReached(true);
    }

    return () => media.removeEventListener('change', updateTarget);
  }, [width, showSecond, setShowSecond]);
  return targetReached;
};

const Header = () => {
  const [showSecond, setShowSecond] = useState(false);
  const isMdScreen = useMediaQuery(998, showSecond, setShowSecond);
  return (
    // sticky
    <div className="bg-black sticky top-[-2px] z-50">
      <nav className="  w-full mx-auto max-w-[1440px]">
        <div className="flex w-[90%] py-5 lg:py-0 mx-auto justify-between items-center ">
          <div>
            <h3 className="text-green-500 hover:scale-105 duration-200  text-2xl font-bold tracking-widest cursor-pointer">
              <HashLink smooth to="/#home" >
              &lt;Jawad /&gt;
              </HashLink>
              
              {/* Protfolio{" "}
              <span className="font-raleway">of </span>Adil */}
            </h3>
          </div>
          {showSecond === false ? (
            <FaAlignRight
              onClick={() => setShowSecond(!showSecond)}
              className="sideMenuIcon  text-4xl text-white"
            ></FaAlignRight>
          ) : (
            <FaRegTimesCircle
              onClick={() => setShowSecond(!showSecond)}
              className="sideMenuIcon  text-4xl text-white"
            ></FaRegTimesCircle>
          )}
          <div className="menuBar">
            <ul className="flex flex-col md:flex-row space-x-2 bg-black justify-center py-5 ">
              <li className="font-semibold tracking-widest duration-200 rounded-md hover:scale-105  px-3 py-2  font-semibold text-green-500 font-roboto">
                <HashLink smooth to="/#about">
                  &lt;About /&gt;
                </HashLink>
              </li>
              <li className="font-semibold tracking-widest duration-200 rounded-md hover:scale-105  px-3 py-2  font-semibold text-green-500 font-roboto">
                <HashLink smooth to="/#services">
                  &lt;Services /&gt;
                </HashLink>
              </li>
              <li className="font-semibold tracking-widest duration-200 rounded-md hover:scale-105  px-3 py-2  font-semibold text-green-500 font-roboto">
                <HashLink smooth to="/#skills">
                  &lt;Skills /&gt;
                </HashLink>
              </li>
              <li className="font-semibold tracking-widest duration-200 rounded-md hover:scale-105  px-3 py-2  font-semibold text-green-500 font-roboto">
                <HashLink smooth to="/#works">
                  &lt;Works /&gt;
                </HashLink>
              </li>
              {/* <li className="font-wetpaint font-normal tracking-widest duration-200 rounded-md hover:bg-green-500  px-3 py-2 text-xl font-semibold text-green-500 hover:text-white font-roboto">
                <HashLink smooth to="/#resumes">
                  Resume
                </HashLink>
              </li> */}

              {/* <li className="duration-200 rounded-md hover:bg-green-500  px-3 py-2 text-xl font-semibold text-green-500 hover:text-white font-roboto">
              
                Blogs
              </li> */}
              <li className=" font-semibold tracking-widest duration-200 rounded-md hover:scale-105  px-3 py-2  font-semibold text-green-500 font-roboto">
                <HashLink smooth to="/#contact">
                  &lt;Contact /&gt;
                </HashLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div
        className={`wrapper w-full bg-black ${showSecond && !isMdScreen ? 'open' : ''}`}
      >
        <div className={`expandable w-[80%] mx-auto`}>
          <ul className=" bg-black  py-5 ">
            <li className="duration-200 rounded-md hover:bg-[#5a7d9a]  px-3 py-2 text-xl font-semibold text-white font-raleway">
              <HashLink smooth to="/#about">
                About
              </HashLink>
            </li>
            <li className="duration-200 rounded-md hover:bg-[#5a7d9a]  px-3 py-2 text-xl font-semibold text-white font-raleway">
              <HashLink smooth to="/#services">
                Services
              </HashLink>
            </li>
            <li className="duration-200 rounded-md hover:bg-[#5a7d9a]  px-3 py-2 text-xl font-semibold text-white font-raleway">
              <HashLink smooth to="/#skills">
                Skills
              </HashLink>
            </li>
            <li className="duration-200 rounded-md hover:bg-[#5a7d9a]  px-3 py-2 text-xl font-semibold text-white font-raleway">
              <HashLink smooth to="/#works">
                Works
              </HashLink>
            </li>
            {/* <li className="duration-200 rounded-md hover:bg-[#5a7d9a]  px-3 py-2 text-xl font-semibold text-white font-raleway">
              <HashLink smooth to="/#resumes">
                Resume
              </HashLink>
            </li> */}

            {/* <li className="duration-200 rounded-md hover:bg-[#5a7d9a]  px-3 py-2 text-xl font-semibold text-white font-raleway">
              
              Blogs
            </li> */}
            <li className="duration-200 rounded-md hover:bg-[#5a7d9a]  px-3 py-2 text-xl font-semibold text-white font-raleway">
              <HashLink smooth to="/#contact">
                Contact
              </HashLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};



export default Header;
